import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './ProjectsSearchResults.css';
import ProjectCard from '../ProjectCard/ProjectCard';

const ProjectsSearchResults = ({ projects = [] }) => {
  const [viewMode, setViewMode] = useState('grid');

  return (
    <div className="resultsContainer">
      <div className="viewerSwitcherTabs">
        <a 
          href="#" 
          className={`gridViewTab ${viewMode === 'grid' ? 'activeTab' : ''}`}
          onClick={(e) => {
            e.preventDefault();
            setViewMode('grid');
          }}
        >
          <span>Grid View</span>
        </a>
        <a 
          href="#" 
          className={`listViewTab ${viewMode === 'list' ? 'activeTab' : ''}`}
          onClick={(e) => {
            e.preventDefault();
            setViewMode('list');
          }}
        >
          <span>List View</span>
        </a>
      </div>

      <div className="resultsWrapperContainer">
        {viewMode === 'grid' ? (
          <div className="mainProjectCard">
            {projects.map((project, index) => (
              <ProjectCard key={project.project_id} project={project} index={index} />
            ))}
          </div>
        ) : (
          <div className="listViewProjects">
            <table className="uk-table uk-table-divider">
              <thead>
                <tr>
                  <th>Project Name</th>
                  <th>Location</th>
                  <th>Stage</th>
                  <th>Commodity</th>
                  <th>View</th>
                </tr>
              </thead>
              <tbody>
                {projects.map((project) => (
                  <tr key={project.project_id}>
                    <td>{project.project_name}</td>
                    <td>{project.location}</td>
                    <td>{project.stage}</td>
                    <td>{project.commodity}</td>
                    <td>
                      <Link to={`/project/${project.project_id}`} className="viewProjectBtn">
                        View <span className="iconWrapper"></span>
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProjectsSearchResults; 